import { ArrowForwardIos, ContentCopy, Delete } from "@mui/icons-material";
import { HiOutlinePuzzle } from "react-icons/hi";
import React, { memo } from "react";
import { Handle } from "react-flow-renderer";
import { useNodeStorage } from "../../../stores/useNodeStorage";

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();

  return (
    <div
      style={{
        backgroundColor: "#FAFBFF",
        padding: "12px",
        borderRadius: "8px",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
        border: "1px solid rgba(236, 88, 88, 0.3)",
        width: "180px",
        transition: "all 0.2s ease",
        position: "relative"
      }}
    >
      <Handle
        type="target"
        position="left"
        style={{
          background: "linear-gradient(45deg, #EC5858, #d44848)",
          width: "16px",
          height: "16px",
          top: "50%",
          left: "-8px",
          cursor: 'pointer',
          border: "2px solid #ffffff"
        }}
        onConnect={params => console.log("handle onConnect", params)}
        isConnectable={isConnectable}
      >
        <ArrowForwardIos
          sx={{
            color: "#ffffff",
            width: "10px",
            height: "10px",
            marginLeft: "1px",
            marginBottom: "1px",
            pointerEvents: 'none',
            transform: "rotate(180deg)"
          }}
        />
      </Handle>

      <div
        style={{
          position: "absolute",
          right: "8px",
          top: "8px",
          display: "flex",
          gap: "4px"
        }}
      >
        <ContentCopy
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("duplicate");
          }}
          sx={{ 
            width: "14px", 
            height: "14px", 
            color: "#94a3b8",
            cursor: "pointer",
            "&:hover": { color: "#EC5858" }
          }}
        />
        <Delete
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("delete");
          }}
          sx={{ 
            width: "14px", 
            height: "14px", 
            color: "#94a3b8",
            cursor: "pointer",
            "&:hover": { color: "#ef4444" }
          }}
        />
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "8px"
        }}
      >
        <HiOutlinePuzzle
          style={{
            width: "16px",
            height: "16px",
            marginRight: "6px",
            color: "#EC5858"
          }}
        />
        <div style={{ 
          color: "#1a1a1a", 
          fontSize: "14px",
          fontWeight: "600"
        }}>
          Pergunta
        </div>
      </div>

      <div style={{ 
        color: "#374151", 
        fontSize: "12px",
        lineHeight: "1.4",
        maxHeight: "60px",
        overflowY: "auto",
        padding: "6px",
        backgroundColor: "#f8fafc",
        borderRadius: "4px",
        border: "1px solid #e2e8f0",
        marginBottom: "8px"
      }}>
        {data?.typebotIntegration?.message}
      </div>

      <Handle
        type="source"
        position="right"
        id="a"
        style={{
          background: "linear-gradient(45deg, #EC5858, #d44848)",
          width: "16px",
          height: "16px",
          top: "50%",
          right: "-8px",
          cursor: 'pointer',
          border: "2px solid #ffffff"
        }}
        isConnectable={isConnectable}
      >
        <ArrowForwardIos
          sx={{
            color: "#ffffff",
            width: "10px",
            height: "10px",
            marginLeft: "1px",
            marginBottom: "1px",
            pointerEvents: 'none'
          }}
        />
      </Handle>
    </div>
  );
});